export default __webpack_public_path__ + "static/media/new-no-data.e138d8e8.svg";